var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"modal overflow"},[_vm._t("title"),_vm._t("body"),_vm._t("politica"),_vm._t("check"),_vm._t("footer")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }